export default __webpack_public_path__ + "static/media/cave_banner.c796ed06.png";